<span class="ag-cell-value" *ngIf="isValidDate">{{ params.value | date: 'M/d/yyyy h:mm a' }}</span>
<span class="ag-cell-value" *ngIf="!isValidDate">{{ params.value }}</span>
